/* ============================================================
   LUXE LINEN — theme.js (vanilla, no dependencies)
   ============================================================ */
(function () {
  'use strict';

  var moneyFormat = 'Rs {{amount}}';

  /* ---------- Helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return moneyFormat.replace('{{amount}}', parts.join('.'));
  }

  function fetchJSON(url, options) {
    return fetch(url, options).then(function (res) {
      if (!res.ok) throw new Error('Request failed: ' + res.status);
      return res.json();
    });
  }

  /* ---------- Cart drawer ---------- */
  var drawer = $('[data-cart-drawer]');
  var overlay = $('[data-drawer-overlay]');

  function openDrawer() {
    if (!drawer) return;
    renderCart().catch(function () {});
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.hidden = true;
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-open]')) { e.preventDefault(); openDrawer(); }
    if (e.target.closest('[data-drawer-close]') || e.target === overlay) { closeDrawer(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); closeMobileNav(); }
  });

  function updateCountBubbles(count) {
    $all('[data-cart-count-bubble]').forEach(function (el) {
      el.textContent = el.classList.contains('cart-drawer__count') ? '(' + count + ')' : count;
      if (el.classList.contains('cart-count')) el.hidden = count === 0;
    });
  }
function formatAmount(cents) {
  var amount = (cents / 100).toFixed(2);
  var parts = amount.split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return parts[0];
}
function formatPKR(cents) { return formatAmount(cents) + ' PKR'; }

var GIFT_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><rect x="3" y="8" width="18" height="4"/><path d="M5 12v8h14v-8M12 8v12M12 8s-4.5.2-5.5-1.5C5.7 5 7 3.5 8.6 4.2 10 4.8 12 8 12 8zm0 0s4.5.2 5.5-1.5c.8-1.5-.5-3-2.1-2.3C14 4.8 12 8 12 8z"/></svg>';

function promoStepsHTML(count, threshold) {
  var html = '';
  for (var i = 1; i <= threshold; i++) {
    var done = i <= count;
    var last = i === threshold;
    html += '<div class="promo-step' + (done ? ' is-done' : '') + '">' +
      '<span class="promo-step__dot">' + (last ? GIFT_SVG : i) + '</span>' +
      '<span class="promo-step__label">' + (last ? 'FREE' : 'ITEM ' + i) + '</span>' +
      '</div>';
    if (!last) html += '<span class="promo-step__line' + (i < count ? ' is-done' : '') + '"></span>';
  }
  return html;
}
function promoTitleHTML(tpl, remaining) {
  return tpl.replace('{remaining}', remaining).replace('1 FREE', '<span class="promo-free">1 FREE</span>');
}

  function cartItemHTML(item) {
  var img = item.image
    ? '<img src="' + item.image + '" alt="' + escapeHTML(item.title) + '" loading="lazy">'
    : '';
  return '' +
    '<div class="d-item" data-line-key="' + item.key + '">' +
      '<div class="d-item__media">' + img + '</div>' +
      '<div class="d-item__body">' +
        '<p class="d-item__title">' + escapeHTML(item.product_title) + '</p>' +
        '<p class="d-item__price">' + formatPKR(item.final_line_price) + '</p>' +
        (item.variant_title ? '<p class="d-item__variant">' + escapeHTML(item.variant_title) + '</p>' : '') +
        '<div class="d-item__row">' +
          '<span class="d-item__qty">' +
            '<button type="button" data-d-dec aria-label="Decrease quantity">−</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button type="button" data-d-inc aria-label="Increase quantity">+</button>' +
          '</span>' +
          '<button type="button" class="d-item__remove" data-d-remove>Remove</button>' +
        '</div>' +
      '</div>' +
    '</div>';
}


  function escapeHTML(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function renderCart() {
  return fetchJSON('/cart.js').then(function (cart) {
    if (cart.money_format) moneyFormat = cart.money_format;
    updateCountBubbles(cart.item_count);

    var itemsWrap = $('[data-cart-items]');
    var footer = $('[data-cart-footer]');
    var subtotalEls = $all('[data-cart-subtotal]');

    if (itemsWrap) {
      itemsWrap.innerHTML = cart.items.length
        ? cart.items.map(cartItemHTML).join('')
        : '<p class="cart-drawer__empty">Your bag is empty.</p>';
    }
    subtotalEls.forEach(function (el) { el.textContent = formatPKR(cart.total_price); });
    if (footer) footer.hidden = cart.items.length === 0;

    /* Promo tracker */
    var promo = $('[data-promo]');
    if (promo && drawer) {
      if (cart.item_count > 0) {
        promo.hidden = false;
        var threshold = Math.max(2, parseInt(drawer.getAttribute('data-promo-threshold') || '4', 10));
        var count = Math.min(cart.item_count, threshold);
        var remaining = threshold - count;
        var titleTpl = drawer.getAttribute('data-promo-title') || 'ADD {remaining} MORE PIECES TO GET 1 FREE';
        var doneTpl = drawer.getAttribute('data-promo-done') || "YOU'VE UNLOCKED YOUR FREE PIECE";
        var textEl = $('[data-promo-text]', promo);
        if (textEl) textEl.innerHTML = remaining > 0 ? promoTitleHTML(titleTpl, remaining) : doneTpl;
        var stepsEl = $('[data-promo-steps]', promo);
        if (stepsEl) stepsEl.innerHTML = promoStepsHTML(count, threshold);
      } else {
        promo.hidden = true;
      }
    }

    /* Cashback banner */
    var cb = $('[data-cashback]');
    if (cb && drawer) {
      if (cart.item_count > 0) {
        cb.hidden = false;
        var pct = parseFloat(drawer.getAttribute('data-cashback-percent') || '10');
        var cbTpl = drawer.getAttribute('data-cashback-text') || 'EARN {amount} PKR CASHBACK ON FIRST ORDER';
        var cbText = $('[data-cashback-text]', cb);
        if (cbText) cbText.textContent = cbTpl.replace('{amount}', formatAmount(Math.round(cart.total_price * pct / 100)));
      } else {
        cb.hidden = true;
      }
    }

    /* Free-shipping note */
    var note = $('[data-ship-note]');
    if (note && drawer) {
      var shipThreshold = parseInt(drawer.getAttribute('data-free-ship-threshold') || '0', 10);
      if (shipThreshold > 0 && cart.item_count > 0) {
        note.hidden = false;
        var freeTxt = drawer.getAttribute('data-ship-free') || "Congrats! You've Earned FREE SHIPPING!";
        var awayTpl = drawer.getAttribute('data-ship-away') || "You're {amount} away from FREE delivery.";
        note.textContent = cart.total_price >= shipThreshold
          ? freeTxt
          : awayTpl.replace('{amount}', formatPKR(shipThreshold - cart.total_price));
      } else {
        note.hidden = true;
      }
    }

    return cart;
  }).catch(function (err) {
    console.warn('Cart fetch failed', err);
    return null;
  });
}


  function addToCart(formData) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    }).then(function (res) {
      if (!res.ok) return res.json().then(function (data) { throw new Error(data.description || 'Could not add to bag.'); });
      return res.json();
    });
  }

  /* Product form → AJAX add */
  $all('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = $('[data-add-to-cart]', form);
      var original = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
      addToCart(new FormData(form))
        .then(function () { return renderCart(); })
        .then(function () { openDrawer(); }) .then(function () { if (btn) { btn.disabled = false; btn.textContent = original; } })

        .catch(function (err) {
          if (btn) btn.textContent = err.message || 'Error — try again';
          setTimeout(function () { if (btn) { btn.disabled = false; btn.textContent = original; } }, 2500);
        })
        .then(function () { if (btn && btn.disabled) { /* restored above on error */ } });
    });
  });

  /* Quick add buttons */
  document.addEventListener('click', function (e) {
    var qa = e.target.closest('[data-quick-add]');
    if (!qa) return;
    e.preventDefault();
    e.stopPropagation();
    var id = qa.getAttribute('data-quick-add');
    if (!id) return;
    qa.disabled = true;
    var fd = new FormData();
    fd.append('id', id);
    fd.append('quantity', '1');
    addToCart(fd)
      .then(function () { return renderCart(); })
      .then(function () { openDrawer(); })
      .catch(function () { window.location.href = '/cart'; })
      .then(function () { qa.disabled = false; });
  });

  /* Buy it now */
  $all('[data-buy-now]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var form = btn.closest('form');
      if (!form) return;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      addToCart(new FormData(form))
        .then(function () { window.location.href = '/checkout'; })
        .catch(function () { window.location.href = '/cart'; });
    });
  });

  /* Drawer qty steppers + remove */
  document.addEventListener('click', function (e) {
    var dec = e.target.closest('[data-d-dec]');
    var inc = e.target.closest('[data-d-inc]');
    var rem = e.target.closest('[data-d-remove]');
    if (!dec && !inc && !rem) return;
    var row = e.target.closest('[data-line-key]');
    if (!row) return;
    var key = row.getAttribute('data-line-key');
    var qtyEl = row.querySelector('.d-item__qty span');
    var qty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
    var next = rem ? 0 : qty + (inc ? 1 : -1);
    if (next < 0) next = 0;
    fetchJSON('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: next })
    }).then(function () { return renderCart(); }).catch(function (err) { console.warn(err); });
  });

  /* Cart page qty + remove */
  $all('[data-cart-qty]').forEach(function (stepper) {
    var key = stepper.getAttribute('data-line-key');
    var input = $('[data-qty-input]', stepper);
    function setQty(qty) {
      fetchJSON('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function () { window.location.reload(); }).catch(function (err) { console.warn(err); });
    }
    $('[data-qty-minus]', stepper).addEventListener('click', function () {
      setQty(Math.max(0, parseInt(input.value || '1', 10) - 1));
    });
    $('[data-qty-plus]', stepper).addEventListener('click', function () {
      setQty(parseInt(input.value || '1', 10) + 1);
    });
    input.addEventListener('change', function () { setQty(Math.max(0, parseInt(input.value || '0', 10))); });
  });
  $all('[data-cart-remove]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      fetchJSON('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: btn.getAttribute('data-cart-remove'), quantity: 0 })
      }).then(function () { window.location.reload(); }).catch(function (err) { console.warn(err); });
    });
  });

  /* Generic qty steppers (product page) */
  $all('[data-qty-stepper]').forEach(function (stepper) {
    if (stepper.hasAttribute('data-cart-qty')) return;
    var input = $('[data-qty-input]', stepper);
    $('[data-qty-minus]', stepper).addEventListener('click', function () {
      input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
    });
    $('[data-qty-plus]', stepper).addEventListener('click', function () {
      input.value = parseInt(input.value || '1', 10) + 1;
    });
  });

  /* Variant selection → price update */
  $all('[data-product-form]').forEach(function (form) {
    var variantSelect = $('[data-variant-select]', form);
    var optionSelects = $all('[data-option-index]', form);
    var priceWrap = document.querySelector('[data-product-price]');
    if (!variantSelect || optionSelects.length === 0) return;

    function currentVariant() {
      var title = optionSelects.map(function (s) { return s.value; }).join(' / ');
      var opts = variantSelect.options;
      for (var i = 0; i < opts.length; i++) {
        if (opts[i].text.trim() === title) return opts[i];
      }
      return null;
    }
    function syncVariant() {
      var opt = currentVariant();
      if (!opt) return;
      variantSelect.value = opt.value;
      if (priceWrap && opt.getAttribute('data-price')) {
        var price = opt.getAttribute('data-price');
        var compare = opt.getAttribute('data-compare');
        var html = '<span class="price-wrap">';
        if (compare && compare !== price) {
          html += '<s class="price-compare">' + escapeHTML(compare) + '</s>';
          html += '<span class="price price--sale">' + escapeHTML(price) + '</span>';
        } else {
          html += '<span class="price">' + escapeHTML(price) + '</span>';
        }
        html += '</span>';
        priceWrap.innerHTML = html;
      }
      var addBtn = $('[data-add-to-cart]', form);
      var available = opt.getAttribute('data-available') === 'true';
      if (addBtn) {
        addBtn.disabled = !available;
        addBtn.textContent = available ? addBtn.getAttribute('data-label') || 'Add to Bag' : 'Sold Out';
      }
    }
    optionSelects.forEach(function (s) { s.addEventListener('change', syncVariant); });
    var addBtnInit = $('[data-add-to-cart]', form);
    if (addBtnInit) addBtnInit.setAttribute('data-label', addBtnInit.textContent);
  });

  /* Product gallery thumbnails */
  $all('[data-gallery-thumbs]').forEach(function (thumbs) {
    var main = thumbs.parentElement.querySelector('[data-gallery-main] img');
    thumbs.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-thumb-src]');
      if (!btn || !main) return;
      main.src = btn.getAttribute('data-thumb-src');
      $all('.thumb', thumbs).forEach(function (t) { t.classList.remove('is-active'); });
      btn.classList.add('is-active');
    });
  });

  /* Hero slideshow */
  $all('[data-slideshow]').forEach(function (slider) {
    var slides = $all('.hero-slide', slider);
    var dots = $all('[data-slide-to]', slider);
    if (slides.length < 2) return;
    var index = 0;
    var speed = parseInt(slider.getAttribute('data-speed') || '6000', 10);
    var auto = slider.getAttribute('data-auto-rotate') === 'true';
    var timer = null;

    function go(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === index); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === index); });
    }
    function play() {
      if (!auto) return;
      stop();
      timer = setInterval(function () { go(index + 1); }, speed);
    }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    dots.forEach(function (d) {
      d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-slide-to'), 10)); play(); });
    });
    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', play);
    play();
  });

  /* Testimonial slider (multi-card desktop + autoplay support) */
  $all('[data-testimonial-slider]').forEach(function (slider) {
    var track = $('[data-t-track]', slider);
    var slides = track ? $all('.t-slide', track) : [];
    var dots = $all('[data-t-to]', slider);
    if (!track || slides.length < 2) return;
    var index = 0;
    var auto = slider.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(slider.getAttribute('data-speed') || '5000', 10);
    var timer = null;

    function perView() {
      return window.innerWidth >= 990 ? parseInt(slider.getAttribute('data-per-view') || '1', 10) : 1;
    }
    function maxIndex() { return Math.max(0, slides.length - perView()); }
    function step() { return track.scrollWidth / slides.length; }
    function go(i) {
      var max = maxIndex();
      index = i > max ? 0 : (i < 0 ? max : i);
      track.style.transform = 'translateX(-' + (index * step()) + 'px)';
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === index); });
    }
    function play() {
      stop();
      if (!auto || maxIndex() === 0) return;
      timer = setInterval(function () { go(index + 1); }, speed);
    }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    var prev = $('[data-t-prev]', slider);
    var next = $('[data-t-next]', slider);
    if (prev) prev.addEventListener('click', function () { go(index - 1); play(); });
    if (next) next.addEventListener('click', function () { go(index + 1); play(); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        go(Math.min(parseInt(d.getAttribute('data-t-to'), 10), maxIndex()));
        play();
      });
    });
    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', play);
    window.addEventListener('resize', function () { go(index); });
    play();
  });

  /* Accordions (FAQ + product) */
  $all('[data-accordion]').forEach(function (acc) {
    acc.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-accordion-toggle]');
      if (!toggle) return;
      var item = toggle.closest('.accordion__item');
      var body = item ? item.querySelector('.accordion__body') : null;
      if (!body) return;
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      body.hidden = open;
    });
  });

  /* Mobile nav */
  var mobileNav = $('[data-mobile-nav]');
  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove('open');
    mobileNav.hidden = true;
    $all('[data-mobile-nav-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  }
  $all('[data-mobile-nav-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var open = mobileNav.classList.toggle('open');
      mobileNav.hidden = !open;
      btn.setAttribute('aria-expanded', String(open));
    });
  });

  /* Reveal on scroll */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('in'); io.unobserve(entry.target); }
      });
    }, { threshold: 0.12 });
    $all('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    $all('.reveal').forEach(function (el) { el.classList.add('in'); });
  }

  /* Collection sort */
  var sortSelect = $('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  /* Header: hide on scroll down, reveal on scroll up */
  var scrollHeader = document.querySelector('[data-header-scrollup]');
  if (scrollHeader) {
    var lastY = window.scrollY;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      if (y > lastY && y > 250) { scrollHeader.classList.add('site-header--hidden'); }
      else { scrollHeader.classList.remove('site-header--hidden'); }
      lastY = y;
    }, { passive: true });
  }

  /* ---------- Quick view modal ---------- */
  var qvModal = $('[data-quick-view-modal]');
  var qvOverlay = $('[data-quick-view-overlay]');
  var qvContent = $('[data-quick-view-content]');

  function qvImg(src, width) {
    if (!src) return '';
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function openQuickView() {
    if (!qvModal) return;
    qvModal.hidden = false;
    qvOverlay.hidden = false;
    requestAnimationFrame(function () {
      qvModal.classList.add('open');
      qvOverlay.classList.add('open');
    });
    document.body.style.overflow = 'hidden';
  }

  function closeQuickView() {
    if (!qvModal || qvModal.hidden) return;
    qvModal.classList.remove('open');
    qvOverlay.classList.remove('open');
    document.body.style.overflow = '';
    setTimeout(function () { qvModal.hidden = true; qvOverlay.hidden = true; }, 300);
  }

  function quickViewHTML(p) {
    var img = (p.images && p.images[0])
      ? '<img src="' + qvImg(p.images[0], 900) + '" alt="' + escapeHTML(p.title) + '">'
      : '';
    var variants = p.variants || [];
    var first = variants[0] || {};
    var variantField;
    if (variants.length > 1) {
      var opts = variants.map(function (v) {
        return '<option value="' + v.id + '" data-price="' + v.price + '"' +
          (v.available ? '' : ' disabled') + '>' +
          escapeHTML(v.title) + (v.available ? '' : ' — Sold out') + '</option>';
      }).join('');
      variantField = '<label class="qv-modal__label">Options' +
        '<select class="qv-modal__select" data-qv-variant>' + opts + '</select></label>';
    } else {
      variantField = '<input type="hidden" data-qv-variant value="' + (first.id || '') + '">';
    }
    return '' +
      '<div class="qv-modal__grid">' +
        '<div class="qv-modal__media">' + img + '</div>' +
        '<div class="qv-modal__info">' +
          '<h3 class="qv-modal__title">' + escapeHTML(p.title) + '</h3>' +
          '<p class="qv-modal__price" data-qv-price><span class="price">' + formatMoney(first.price || 0) + '</span></p>' +
          variantField +
          '<div class="qv-modal__row">' +
            '<div class="qty-stepper" data-qv-qty>' +
              '<button type="button" data-qv-minus aria-label="Decrease quantity">−</button>' +
              '<input type="number" value="1" min="1" data-qv-input aria-label="Quantity">' +
              '<button type="button" data-qv-plus aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<button type="button" class="btn btn--primary" data-qv-add>Add to Bag</button>' +
          '</div>' +
          '<a class="link-btn" href="/products/' + p.handle + '">View full details</a>' +
        '</div>' +
      '</div>';
  }

  function wireQuickViewForm() {
    var sel = $('[data-qv-variant]', qvContent);
    var priceEl = $('[data-qv-price]', qvContent);
    if (sel && sel.tagName === 'SELECT') {
      sel.addEventListener('change', function () {
        var opt = sel.options[sel.selectedIndex];
        if (priceEl) {
          priceEl.innerHTML = '<span class="price">' +
            formatMoney(parseInt(opt.getAttribute('data-price') || '0', 10)) + '</span>';
        }
      });
    }
    var qtyWrap = $('[data-qv-qty]', qvContent);
    if (qtyWrap) {
      var input = $('[data-qv-input]', qtyWrap);
      $('[data-qv-minus]', qtyWrap).addEventListener('click', function () {
        input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
      });
      $('[data-qv-plus]', qtyWrap).addEventListener('click', function () {
        input.value = parseInt(input.value || '1', 10) + 1;
      });
    }
    var addBtn = $('[data-qv-add]', qvContent);
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var variantId = sel ? sel.value : null;
        if (!variantId) return;
        addBtn.disabled = true;
        var fd = new FormData();
        fd.append('id', variantId);
        fd.append('quantity', ($('[data-qv-input]', qvContent) || {}).value || '1');
        addToCart(fd)
          .then(function () { return renderCart(); })
          .then(function () { closeQuickView(); openDrawer(); })
          .catch(function () { window.location.href = '/cart'; })
          .then(function () { addBtn.disabled = false; });
      });
    }
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-quick-view-close]') || e.target === qvOverlay) { closeQuickView(); return; }
    var trigger = e.target.closest('[data-quick-view]');
    if (!trigger || !qvContent) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = trigger.getAttribute('data-quick-view');
    if (!handle) return;
    qvContent.innerHTML = '<p class="qv-modal__loading">Loading…</p>';
    openQuickView();
    fetchJSON('/products/' + handle + '.js')
      .then(function (p) {
        qvContent.innerHTML = quickViewHTML(p);
        wireQuickViewForm();
      })
      .catch(function () {
        qvContent.innerHTML = '<p class="qv-modal__loading">Could not load this product.</p>';
      });
  });

  /* ---------- Recently viewed: track on product pages ---------- */
  var RECENT_KEY = 'lux_recently_viewed';
  (function trackRecent() {
    var el = $('[data-product-handle]');
    if (!el) return;
    var handle = el.getAttribute('data-product-handle');
    if (!handle) return;
    try {
      var list = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
      list = list.filter(function (x) { return x !== handle; });
      list.unshift(handle);
      localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 12)));
    } catch (err) { /* storage unavailable */ }
  })();

  /* ---------- Recently viewed: render section ---------- */
  function recentCardHTML(p) {
    var img = (p.images && p.images[0])
      ? '<img src="' + qvImg(p.images[0], 600) + '" alt="' + escapeHTML(p.title) + '" loading="lazy">'
      : '';
    var v = (p.variants && p.variants[0]) || {};
    return '' +
      '<div class="recent-card">' +
        '<a class="recent-card__media" href="/products/' + p.handle + '" aria-label="' + escapeHTML(p.title) + '">' + img + '</a>' +
        '<div class="recent-card__info">' +
          '<a class="recent-card__title" href="/products/' + p.handle + '">' + escapeHTML(p.title) + '</a>' +
          '<p class="recent-card__price">' + formatMoney(v.price || 0) + '</p>' +
          '<button type="button" class="link-btn" data-quick-view="' + p.handle + '">Quick view</button>' +
        '</div>' +
      '</div>';
  }

  $all('[data-recently-viewed]').forEach(function (sec) {
    var max = parseInt(sec.getAttribute('data-max') || '4', 10);
    var grid = $('[data-recently-viewed-grid]', sec);
    var current = sec.getAttribute('data-current-handle') || '';
    var list = [];
    try { list = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); } catch (err) {}
    list = list.filter(function (x) { return x && x !== current; }).slice(0, max);
    if (!list.length || !grid) { sec.hidden = true; return; }
    sec.hidden = false;
    Promise.all(list.map(function (h) {
      return fetchJSON('/products/' + h + '.js').catch(function () { return null; });
    })).then(function (products) {
      products = products.filter(Boolean);
      if (!products.length) { sec.hidden = true; return; }
      grid.innerHTML = products.map(recentCardHTML).join('');
    });
  });

  /* ---------- Newsletter popup ---------- */
  var popup = $('[data-newsletter-popup]');
  var popupOverlay = $('[data-popup-overlay]');
  var POPUP_KEY = 'lux_popup_seen';

  function popupDue() {
    if (!popup) return false;
    var days = parseInt(popup.getAttribute('data-frequency-days') || '7', 10);
    try {
      var last = parseInt(localStorage.getItem(POPUP_KEY) || '0', 10);
      return (Date.now() - last) > days * 86400000;
    } catch (err) { return true; }
  }
  function markPopupSeen() {
    try { localStorage.setItem(POPUP_KEY, String(Date.now())); } catch (err) {}
  }
  function openPopup() {
    if (!popup || popup.hidden === false) return;
    popup.hidden = false;
    popupOverlay.hidden = false;
    document.body.style.overflow = 'hidden';
    markPopupSeen();
  }
  function closePopup() {
    if (!popup || popup.hidden) return;
    popup.hidden = true;
    popupOverlay.hidden = true;
    document.body.style.overflow = '';
  }

  if (popup && popupDue()) {
    var popupShown = false;
    var popupDelay = parseInt(popup.getAttribute('data-delay') || '12', 10) * 1000;
    function showPopupOnce() {
      if (popupShown) return;
      popupShown = true;
      openPopup();
    }
    setTimeout(showPopupOnce, popupDelay);
    if (popup.getAttribute('data-exit-intent') === 'true') {
      document.addEventListener('mouseleave', function (e) {
        if (e.clientY <= 0) showPopupOnce();
      });
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-popup-close]') || e.target === popupOverlay) closePopup();
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeQuickView(); closePopup(); }
  });

  /* ---------- New homepage sections: Shop the Look, Countdown, Tabs ---------- */

  /* Shop the Look hotspots */
  $all('[data-shop-look]').forEach(function (section) {
    var spots = $all('[data-shop-look-spot]', section);
    function closeAll(except) {
      spots.forEach(function (spot) {
        if (spot === except) return;
        var card = $('[data-shop-look-card]', spot);
        var pin = $('[data-shop-look-pin]', spot);
        if (card) card.hidden = true;
        if (pin) pin.setAttribute('aria-expanded', 'false');
      });
    }
    spots.forEach(function (spot) {
      var pin = $('[data-shop-look-pin]', spot);
      var card = $('[data-shop-look-card]', spot);
      if (!pin || !card) return;
      pin.addEventListener('click', function (e) {
        e.stopPropagation();
        var willOpen = card.hidden;
        closeAll(spot);
        card.hidden = !willOpen;
        pin.setAttribute('aria-expanded', String(willOpen));
      });
      var closeBtn = $('[data-shop-look-close]', card);
      if (closeBtn) {
        closeBtn.addEventListener('click', function (e) { e.stopPropagation(); closeAll(); });
      }
    });
    section.addEventListener('click', function (e) {
      if (!e.target.closest('[data-shop-look-spot]')) closeAll();
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $all('[data-shop-look-card]').forEach(function (c) { c.hidden = true; });
    $all('[data-shop-look-pin]').forEach(function (p) { p.setAttribute('aria-expanded', 'false'); });
  });

  /* Countdown banners — hide automatically after expiry */
  $all('[data-countdown]').forEach(function (banner) {
    var raw = (banner.getAttribute('data-end') || '').trim();
    var m = raw.match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})$/);
    if (!m) { banner.style.display = 'none'; return; }
    var target = new Date(+m[1], +m[2] - 1, +m[3], +m[4], +m[5]);
    if (isNaN(target.getTime())) { banner.style.display = 'none'; return; }
    var dEl = $('[data-cd-days]', banner);
    var hEl = $('[data-cd-hours]', banner);
    var minEl = $('[data-cd-mins]', banner);
    var sEl = $('[data-cd-secs]', banner);
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var diff = target.getTime() - Date.now();
      if (diff <= 0) { banner.style.display = 'none'; clearInterval(timer); return; }
      var total = Math.floor(diff / 1000);
      if (dEl) dEl.textContent = pad(Math.floor(total / 86400));
      if (hEl) hEl.textContent = pad(Math.floor(total % 86400 / 3600));
      if (minEl) minEl.textContent = pad(Math.floor(total % 3600 / 60));
      if (sEl) sEl.textContent = pad(total % 60);
    }
    var timer = setInterval(tick, 1000);
    tick();
  });

  /* Tabbed products */
  $all('[data-tabs]').forEach(function (tabs) {
    var btns = $all('[data-tab-btn]', tabs);
    var panels = $all('[data-tab-panel]', tabs);
    if (btns.length < 2) return;
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-tab-btn');
        btns.forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-selected', String(on));
        });
        panels.forEach(function (p) { p.hidden = p.getAttribute('data-tab-panel') !== key; });
      });
    });
  });

  /* Sync drawer on load (silent) */
  renderCart().catch(function () {});

  /* ============ PRODUCT PAGE UPGRADES (vanilla JS) ============ */

  /* Sticky add-to-cart bar: slides in after scrolling past the main buy button.
     The Add button always uses the currently selected variant + quantity. */
  (function stickyATC() {
    var bar = $('[data-sticky-atc]');
    if (!bar) return;
    var form = $('[data-product-form]');
    var buyBtn = form ? $('[data-add-to-cart]', form) : null;
    var addBtn = $('[data-sticky-add]', bar);
    var variantEl = $('[data-sticky-variant]', bar);
    var priceEl = $('[data-sticky-price]', bar);

    function selectedOption() {
      var sel = form ? $('[data-variant-select]', form) : null;
      if (!sel || sel.tagName !== 'SELECT') return null;
      return sel.options[sel.selectedIndex] || null;
    }
    function syncFromVariant() {
      var opt = selectedOption();
      if (!opt) return;
      if (variantEl) variantEl.textContent = opt.text.trim();
      var price = opt.getAttribute('data-price');
      if (priceEl && price) priceEl.textContent = price;
      if (addBtn) {
        addBtn.setAttribute('data-variant-id', opt.value);
        addBtn.disabled = opt.getAttribute('data-available') !== 'true';
      }
    }
    if (form) {
      $all('[data-option-index]', form).forEach(function (s) {
        s.addEventListener('change', syncFromVariant);
      });
    }

    function setVisible(v) {
      bar.classList.toggle('is-visible', v);
      document.body.classList.toggle('has-sticky-atc', v);
    }
    if (buyBtn && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var r = entries[0];
        setVisible(!r.isIntersecting && r.boundingClientRect.top < 0);
      }, { threshold: 0 });
      io.observe(buyBtn);
    } else if (buyBtn) {
      window.addEventListener('scroll', function () {
        setVisible(buyBtn.getBoundingClientRect().top < 0);
      }, { passive: true });
    }

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var id = addBtn.getAttribute('data-variant-id');
        if (!id || addBtn.disabled) return;
        var qtyInput = form ? $('[data-qty-input]', form) : null;
        var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value || '1', 10)) : 1;
        var label = addBtn.textContent;
        addBtn.disabled = true;
        addBtn.textContent = 'Adding\u2026';
        var fd = new FormData();
        fd.append('id', id);
        fd.append('quantity', String(qty));
        addToCart(fd)
          .then(function () { return renderCart(); })
          .then(function () { openDrawer(); })
          .catch(function () { window.location.href = '/cart'; })
          .then(function () { addBtn.textContent = label; syncFromVariant(); });
      });
    }
  })();

  /* Low-stock indicator: follows the selected variant, hides when untracked. */
  (function stockIndicator() {
    var el = $('[data-stock-indicator]');
    if (!el) return;
    var form = $('[data-product-form]');
    var threshold = parseInt(el.getAttribute('data-threshold') || '5', 10);
    var countEl = $('[data-stock-count]', el);
    function update() {
      var sel = form ? $('[data-variant-select]', form) : null;
      var opt = (sel && sel.tagName === 'SELECT') ? sel.options[sel.selectedIndex] : null;
      if (!opt) return; /* single variant: keep the server-rendered state */
      var tracked = opt.getAttribute('data-tracked') === 'true';
      var inv = parseInt(opt.getAttribute('data-inventory') || '0', 10);
      if (tracked && inv > 0 && inv <= threshold) {
        if (countEl) countEl.textContent = String(inv);
        el.hidden = false;
      } else {
        el.hidden = true;
      }
    }
    if (form) {
      $all('[data-option-index]', form).forEach(function (s) {
        s.addEventListener('change', update);
      });
    }
  })();

  /* Product info tabs (desktop) / accordion (mobile). */
  $all('[data-product-tabs]').forEach(function (tabs) {
    var tabBtns = $all('[data-tab-btn]', tabs);
    var accBtns = $all('[data-acc-btn]', tabs);
    var panels = $all('[data-tab-panel]', tabs);
    function show(id) {
      panels.forEach(function (p) { p.hidden = p.getAttribute('data-tab-panel') !== id; });
      tabBtns.forEach(function (b) {
        var on = b.getAttribute('data-tab-btn') === id;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      accBtns.forEach(function (b) {
        b.setAttribute('aria-expanded', b.getAttribute('data-acc-btn') === id ? 'true' : 'false');
      });
    }
    tabBtns.forEach(function (b) {
      b.addEventListener('click', function () { show(b.getAttribute('data-tab-btn')); });
    });
    accBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        var id = b.getAttribute('data-acc-btn');
        var panel = tabs.querySelector('[data-tab-panel="' + id + '"]');
        if (panel && !panel.hidden) {
          panel.hidden = true;
          b.setAttribute('aria-expanded', 'false');
        } else {
          show(id);
        }
      });
    });
  });

  /* Size guide modal: overlay click + Escape to close, loose focus trap. */
  $all('[data-size-guide-modal]').forEach(function (modal) {
    var dialog = $('.ll-modal__dialog', modal);
    var lastFocus = null;
    function focusables() {
      return $all('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])', dialog)
        .filter(function (el) { return !el.disabled && el.offsetParent !== null; });
    }
    function open(e) {
      if (e) e.preventDefault();
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.body.classList.add('modal-open');
      var f = focusables();
      if (f.length) f[0].focus();
      else if (dialog) dialog.focus();
    }
    function close() {
      modal.hidden = true;
      document.body.classList.remove('modal-open');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-size-guide-open]')) open(e);
      else if (e.target.closest('[data-size-guide-close]')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (modal.hidden) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'Tab') {
        var f = focusables();
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  });
})();

  /* Transparent header: solid on scroll (unless sticky is off) */
  (function () {
    var header = document.querySelector('[data-transparent-header]');
    if (!header) return;
    if (header.getAttribute('data-hide-announcement') === 'true') {
      document.documentElement.classList.add('has-transparent-header');
    }
    if (header.getAttribute('data-header-sticky') === 'none') return;
    var onScroll = function () {
      header.classList.toggle('site-header--scrolled', window.scrollY > 80);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();

  /* Mobile nav: expandable submenus */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-submenu-toggle]');
    if (!t) return;
    var li = t.closest('.mobile-nav__item');
    var sub = li ? li.querySelector('.mobile-nav__sublist') : null;
    var open = t.getAttribute('aria-expanded') === 'true';
    t.setAttribute('aria-expanded', String(!open));
    if (sub) sub.hidden = open;
  });

  /* Announcement bar: rotate messages */
  (function () {
    var bar = document.querySelector('[data-announcement-rotate]');
    if (!bar) return;
    var msgs = bar.querySelectorAll('.announcement-bar__msg');
    if (msgs.length < 2) return;
    var secs = parseInt(bar.getAttribute('data-announcement-rotate'), 10) || 5;
    var i = 0;
    setInterval(function () {
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, secs * 1000);
  })();
